/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "backbone",
  "underscore",
  "jquery"
], function (Backbone, _, $) {

  var SEPARATOR = "--";

  var AVAILABLE_FILTER_PREFIXES = {
    FILTER_NESTED: 'filter_n_',
    FILTER: 'filter_',
    DATE: 'date_',
    VALUE: 'value_',
    DATA_SOURCES: "datasources"
  };
  var URLParamsModel = Backbone.Model.extend({
    initialize: function (options) {
      this.options = options;
      this.initialSyncDone = false;
    },

    getCurrentUrl: function () {
      return new URL(window.location);
    },
    isSameAsCurrent: function (params) {
      var currentParams = this.getAll();
      var incomingParams = {};
    
      _.each(params, function (obj) {
        incomingParams[obj.label] = obj.value;
      });
    
      var allKeys = _.union(_.keys(currentParams), _.keys(incomingParams));
    
      return _.every(allKeys, function (key) {
        return currentParams[key] === incomingParams[key];
      });
    },

    setUrlParams: function (params, merge,options) {
      merge = merge || false;
      var url = this.getCurrentUrl();
      var urlChanged = false;
      debugger
      var replace = options && options.replace || false;
      var currentParams = new URLSearchParams(url.searchParams.toString());
      if (merge) {
        _.each(params, function (value, key) {
          if (value !== null && value !== undefined && value !== "") {
            currentParams.set(key, value);
            urlChanged = true;
          } else if (currentParams.has(key)) {
            currentParams.delete(key);
            urlChanged = true;
          }
        });
      } else {
        currentParams = new URLSearchParams();
        _.each(params, function (obj) {
          var value = obj.value, key = obj.label;
          if (value !== null && value !== undefined && value !== "") {
            currentParams.set(key, value);
            urlChanged = true;
          }
        });
      }
      if (urlChanged) {
        url.search = currentParams.toString();
        if (replace) {
          history.replaceState({}, "", url.href);
        } else {
          history.pushState({}, "", url.href);
        }
      }
    },

    updateUrl: function () {
      var currentUrl = window.location.href;
      var newUrl = this.url.href;
      if (currentUrl !== newUrl) {
        history.pushState({}, "", newUrl);
      }
    },

    keys: function () {
      var url = this.getCurrentUrl();
      return Array.from(url.searchParams.keys());
    },

    get: function (key) {
      var url = this.getCurrentUrl();
      return url.searchParams.get(key);
    },

    getAll: function () {
      var url = this.getCurrentUrl();
      var params = {};
      url.searchParams.forEach(function (value, key) {
        params[key] = value;
      });
      return params;
    },

    resetSelectedParams: function () {
      var url = this.getCurrentUrl();
      var paramsToRemove = Object.values(this.options).filter(function (prefix) {
        return prefix && prefix.length > 0;
      });
      var searchParams = new URLSearchParams(url.searchParams.toString());
      var keys = Array.from(searchParams.keys());

      _.each(keys, function (key) {
        var decodedKey = decodeURIComponent(key);
        if (_.some(paramsToRemove, function (prefix) {
          return decodedKey.startsWith(prefix);
        })) {
          searchParams.delete(key);
        }
      });
      url.search = searchParams.toString();
      history.pushState({}, "", url.href);
    }
  });

  var URLParams = new URLParamsModel(AVAILABLE_FILTER_PREFIXES);
  
  return {
    URLParams: URLParams,
    SEPARATOR: SEPARATOR,
    AVAILABLE_FILTER_PREFIXES: AVAILABLE_FILTER_PREFIXES
  };
});
